export default __webpack_public_path__ + "static/media/icon_yclayhang.f1793f88.svg";